import React, { useState } from 'react';
import { Send, CheckCircle } from 'lucide-react';

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    website: '',
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const result = await response.json() as { error?: string };
      if (!response.ok) throw new Error(result.error || "Le message n'a pas pu etre envoye.");

      setIsSubmitted(true);
      setFormData({ name: '', email: '', message: '', website: '' });
      setTimeout(() => setIsSubmitted(false), 3000);
    } catch (submitError) {
      setError(submitError instanceof Error ? submitError.message : "Le message n'a pas pu etre envoye.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-lg mx-auto">
      <div className="absolute left-[-10000px]" aria-hidden="true">
        <label htmlFor="website">Site internet</label>
        <input
          type="text"
          id="website"
          name="website"
          tabIndex={-1}
          autoComplete="off"
          value={formData.website}
          onChange={handleChange}
        />
      </div>
      <div className="mb-6">
        <label htmlFor="name" className="block text-primary-700 font-medium mb-2">
          Nom complet
        </label>
        <input
          type="text"
          id="name"
          name="name"
          required
          value={formData.name}
          onChange={handleChange}
          className="w-full px-4 py-3 rounded-lg border border-primary-200 focus:border-secondary-500 focus:ring-2 focus:ring-secondary-200 outline-none transition-all"
          placeholder="Votre nom"
        />
      </div>

      <div className="mb-6">
        <label htmlFor="email" className="block text-primary-700 font-medium mb-2">
          Email
        </label>
        <input
          type="email"
          id="email"
          name="email"
          required
          value={formData.email}
          onChange={handleChange}
          className="w-full px-4 py-3 rounded-lg border border-primary-200 focus:border-secondary-500 focus:ring-2 focus:ring-secondary-200 outline-none transition-all"
          placeholder="votre@email.com"
        />
      </div>

      <div className="mb-6">
        <label htmlFor="message" className="block text-primary-700 font-medium mb-2">
          Message
        </label>
        <textarea
          id="message"
          name="message"
          required
          value={formData.message}
          onChange={handleChange}
          rows={5}
          className="w-full px-4 py-3 rounded-lg border border-primary-200 focus:border-secondary-500 focus:ring-2 focus:ring-secondary-200 outline-none transition-all resize-none"
          placeholder="Votre message..."
        />
      </div>

      {error && (
        <p className="mb-4 text-sm text-red-700" role="alert">
          {error}
        </p>
      )}

      <button
        type="submit"
        disabled={isSubmitting || isSubmitted}
        className="w-full bg-secondary-500 text-white py-3 px-6 rounded-lg hover:bg-secondary-600 transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isSubmitted ? (
          <>
            <CheckCircle className="w-5 h-5" />
            Message envoyé !
          </>
        ) : isSubmitting ? (
          'Envoi en cours...'
        ) : (
          <>
            <Send className="w-5 h-5" />
            Envoyer
          </>
        )}
      </button>
    </form>
  );
}
